<template>
  <WdsStack direction-column gap-sm>
    <WdsSelect
      v-model="selectedValue"
      class="tw-w-full"
      :label="$t('Has timesheet')"
      :list="booleanOptions"
      :placeholder="$t('All')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const model = defineModel<boolean | null>({
  default: null,
})

const booleanOptions = [
  { value: true, label: $t('Yes') },
  { value: false, label: $t('No') },
]

const selectedValue = computed({
  get() {
    if (model.value !== null && model.value !== undefined) {
      return booleanOptions.find((opt) => opt.value === model.value) ?? null
    }
    return null
  },
  set(option: { value: boolean; label: string } | null) {
    model.value = option?.value ?? null
  },
})
</script>
